<ion-header data-page="accueil">
  <ion-toolbar color="primary">
    <ion-buttons slot="start" class="with-badge">
      <ion-menu-button />
      <ion-badge class="burger-badge" *ngIf="burgerBadge as badge">{{ badge }}</ion-badge>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="with-badge" (click)="openCentreNotification()">
        <ion-icon name="notifications" id="notification-icon"></ion-icon>
        @if (notificationsNonLues() > 0) {
          <ion-badge class="badge-notification" color="danger">
            {{ notificationsNonLues() }}
          </ion-badge>
        }
      </ion-button>
      <ion-button icon-only (click)="openRechercheModal()">
        <ion-icon name="search"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="content">
  <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  @if (user && user.prenom) {
    <div class="welcome">
      <span class="name">{{ 'HOME.WELCOME_MESSAGE' | translate: { prenom: user.prenom } | titlecase }}</span>
    </div>
  }

  <daily-ots-widget [resetSubject]="resetSubject.asObservable()"></daily-ots-widget>
  <conduite-p1-widget [resetSubject]="resetSubject.asObservable()"></conduite-p1-widget>
  <acces-rapide-widget [resetSubject]="resetSubject.asObservable()"></acces-rapide-widget>
  <sites-favoris-widget [resetSubject]="resetSubject.asObservable()"></sites-favoris-widget>
  <heures-saisies-widget [resetSubject]="resetSubject.asObservable()"></heures-saisies-widget>
</ion-content>
